import { P as c, b as k, n as o, t as b } from "./element-CV9utnHJ.js";
import { o as h } from "./if-defined-rXcLNTzN.js";
import "./icon-D0IQAVwS.js";
var f = Object.defineProperty, u = Object.getOwnPropertyDescriptor, n = (t, r, i, l) => {
  for (var e = l > 1 ? void 0 : l ? u(r, i) : r, s = t.length - 1, p; s >= 0; s--)
    (p = t[s]) && (e = (l ? p(r, i, e) : p(e)) || e);
  return l && e && f(r, i, e), e;
};
let a = class extends c {
  constructor() {
    super(...arguments), this.href = "", this.text = "Forsiden", this.ariaLabel = "";
  }
  // Lifecycle
  attributeChangedCallback(t, r, i) {
    t === "arialabel" && this.removeAttribute("arialabel"), t === "href" && this.removeAttribute("href"), t === "text" && this.removeAttribute("text"), super.attributeChangedCallback(t, r, i);
  }
  render() {
    return k`<nav
      class="pkt-back-link"
      aria-label=${this.ariaLabel || "Gå tilbake til forrige side"}
    >
      <a href=${h(this.href || "/")} class="pkt-link pkt-link--icon-left"
        ><pkt-icon
          class="pkt-back-link__icon pkt-icon pkt-link__icon"
          name="chevron-thin-left"
          aria-hidden="true"
        ></pkt-icon
        ><span class="pkt-back-link__text">${this.text}</span></a
      >
    </nav>`;
  }
};
n([
  o({ type: String })
], a.prototype, "href", 2);
n([
  o({ type: String })
], a.prototype, "text", 2);
n([
  o({ type: String })
], a.prototype, "ariaLabel", 2);
a = n([
  b("pkt-backlink")
], a);
export {
  a as P
};
